import { IActivityAddress } from '../interfaces/models';
import { ID } from '@datorama/akita';

export class ActivityAddress implements IActivityAddress {
  id: ID;
  addressId: string;
  name: string;
  doNotKnock: boolean;
  language: string;
  salesPremiseType: string;
  dpWalklistId?: number;
  salesWalklistId?: number;
  address: string;
  derivedDpStatus: string;

  constructor(
    activityAddress: IActivityAddress = {
      id: '',
      addressId: '',
      name: '',
      doNotKnock: false,
      language: '',
      salesPremiseType: '',
      dpWalklistId: null,
      salesWalklistId: null,
      address: '',
      derivedDpStatus: '',
    }
  ) {
    const {
      id,
      addressId,
      name,
      doNotKnock,
      language,
      salesPremiseType,
      dpWalklistId,
      salesWalklistId,
      address,
      derivedDpStatus,
    } = activityAddress;

    this.id = id;
    this.addressId = addressId;
    this.name = name;
    this.doNotKnock = doNotKnock;
    this.language = language;
    this.salesPremiseType = salesPremiseType;
    this.dpWalklistId = dpWalklistId;
    this.salesWalklistId = salesWalklistId;
    this.address = address;
    this.derivedDpStatus = derivedDpStatus;
  }

  static createFromDTO(item): ActivityAddress {
    return new ActivityAddress(item);
  }
}
